import React from "react";
import * as palette from "@govlaunch/palette";
import { IStripeChargeFieldsFragment } from "~/lib/queries/fragments/__generated__/StripeChargeFields.generated";
import * as Types from "~/types/types";
import { FormattedMessage } from "react-intl";
import IntlDateTime from "~/src/shared/components/IntlDateTime";

interface ICurrentBillingNextPaymentDueProps {
  subscription: { __typename: "ActiveSubscription" } & Pick<
    Types.IActiveSubscription,
    "_id" | "nextPaymentDate" | "nextPaymentAmount" | "subscribedAt" | "collectionMethod" | "freeSubscription"
  > & { lastCharge: Types.Maybe<{ __typename: "Charge" } & IStripeChargeFieldsFragment> };
}

export default function CurrentBillingNextPaymentDue({ subscription }: ICurrentBillingNextPaymentDueProps) {
  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
        }}
      >
        <FormattedMessage defaultMessage="Next Payment Due" id="RANMXE" />
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 8,
        }}
      >
        <strong
          css={{
            fontSize: 16,
            fontWeight: 600,
            color: palette.text,
          }}
        >
          {subscription.nextPaymentDate && !subscription.freeSubscription ? (
            <IntlDateTime value={subscription.nextPaymentDate} />
          ) : (
            <FormattedMessage defaultMessage="Not available" id="cPhKTw" />
          )}
        </strong>

        {subscription.nextPaymentAmount !== null && !subscription.freeSubscription && (
          <div>
            <span
              css={{
                fontSize: 13,
                color: "#797979",
              }}
            >
              {subscription.collectionMethod &&
              subscription.collectionMethod === Types.ICollectionMethod.ChargeAutomatically ? (
                <FormattedMessage
                  defaultMessage="We'll charge {amount} by this date"
                  id="KtMzDM"
                  values={{
                    amount: (subscription.nextPaymentAmount / 100).toFixed(2),
                  }}
                />
              ) : (
                <FormattedMessage defaultMessage="We'll email you an invoice by this date" id="yZROtT" />
              )}
            </span>
          </div>
        )}
      </div>
    </>
  );
}
